export default __webpack_public_path__ + "static/media/order-expired.cbb625c0.svg";